// extracted by mini-css-extract-plugin
module.exports = {"staffCode":"EditableList__staffCode--1f2uH","role":"EditableList__role--10erP"};